<template>
  <div class="main-layout">
    <div
      class="router-view"
      :class="{
        'is-collapse': collapse,
        'is-less-tablet': isLessTablet,
      }"
    >
      <coupon-banner />
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { CouponBanner } from '@bizfly/shared';

export default {
  name: 'Layout',
  components: {
    CouponBanner,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('layout', [
      'collapse',
    ]),
    ...mapGetters('device', [
      'isLessTablet',
    ]),
  },
  watch: {
    isLessTablet: {
      handler(value) {
        this.updateHideOverlay(!value);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('layout', ['updateHideOverlay']),
  },
};
</script>

<style lang="scss">
.main-layout {
  .router-view {
    padding: 40px 40px 0 40px;
    margin-left: var(--sidebar-width);
    transition: all 0.2s ease-in;
    &.is-less-tablet {
      margin-left: var(--collapse-sidebar-width);
    }
    &.is-collapse {
      margin-left: var(--collapse-sidebar-width);
      transition: all 0.2s ease-out;
    }
    @media only screen and (max-width: 768px) {
      padding: 30px 30px 10px 30px;
    }
    @media only screen and (max-width: 576px) {
      padding: 15px 15px 10px 15px;
    }
  }
}
</style>
